import {
  ERROR_CONSTRUTOR_MSG,
  GET_TABELAS_RELATORIOS_INIT,
  GET_TABELAS_RELATORIOS_SUCCESS,
  CONSTRUTOR_CLEAN_UP,
  POST_EXECUTA_CONSULTA_RELATORIO_SUCCESS,
  POST_EXECUTA_CONSULTA_RELATORIO_INIT,
  CONSTRUTOR_CONSULTA_NAO_ENCONTRADA,
  CREATE_RELATORIO_INIT,
  CREATE_RELATORIO_SUCCESS,
  UPDATE_RELATORIO_INIT,
  UPDATE_RELATORIO_SUCCESS,
  DELETE_RELATORIO_INIT,
  DELETE_RELATORIO_SUCCESS
} from "../actionTypes";

// =========================================
// TYPES
// =========================================

export interface Relatorio {
  id: string;
  nome: string;
  label: string;
  relatorioBase: string;
  tabelas?: any[];
  [key: string]: any;
}

export interface ConstrutorState {
  loading: boolean;
  isCreated: boolean;
  isUpdated: boolean;
  isDeleted: boolean;
  isError: boolean;
  isConsultaNaoEncontrada: boolean;
  relatoriosCadastrados: Relatorio[];
  dadosConsulta: any[];
  novoRelatorio: Relatorio | null;
  msg: string;
}

export interface ConstrutorAction {
  type: string;
  payload?: any;
}

// =========================================
// INITIAL STATE
// =========================================

const INIT_STATE: ConstrutorState = {
  loading: false,
  isCreated: false,
  isUpdated: false,
  isDeleted: false,
  isError: false,
  isConsultaNaoEncontrada: false,
  relatoriosCadastrados: [],
  dadosConsulta: [],
  novoRelatorio: null,
  msg: "",
};

// =========================================
// REDUCER
// =========================================

export default function construtorReducer(
  state: ConstrutorState = INIT_STATE,
  action: ConstrutorAction
): ConstrutorState {
  switch (action.type) {
    case GET_TABELAS_RELATORIOS_INIT:
      return { ...state, loading: true };

    case GET_TABELAS_RELATORIOS_SUCCESS:
      return {
        ...state,
        relatoriosCadastrados: action.payload.relatoriosCadastrados,
        loading: false,
        isError: false,
      };

    case POST_EXECUTA_CONSULTA_RELATORIO_INIT:
      return { ...state, loading: true, isConsultaNaoEncontrada: false, dadosConsulta: [] };

    case POST_EXECUTA_CONSULTA_RELATORIO_SUCCESS:
      return {
        ...state,
        dadosConsulta: action.payload.dadosConsulta,
        loading: false,
        isError: false,
        isCreated: false,
        isUpdated: false,
        isDeleted: false
      };

    case CREATE_RELATORIO_INIT:
      return { ...state, loading: true, isCreated: false };

    case CREATE_RELATORIO_SUCCESS: {
      const { novoRelatorio, msg } = action.payload;

      return {
        ...state,
        novoRelatorio,
        relatoriosCadastrados: [...state.relatoriosCadastrados, novoRelatorio],
        loading: false,
        isCreated: true,
        msg,
      };
    }

    case UPDATE_RELATORIO_INIT:
      return { ...state, loading: true, isUpdated: false };

    case UPDATE_RELATORIO_SUCCESS: {
      const { relatorioAtualizado, msg } = action.payload;

      return {
        ...state,
        relatoriosCadastrados: state.relatoriosCadastrados.map((relatorioAtual) =>
          relatorioAtual.id === relatorioAtualizado?.id ? { ...relatorioAtual, ...relatorioAtualizado } : relatorioAtual
        ),
        loading: false,
        isUpdated: true,
        msg: msg,
      };
    }

    case DELETE_RELATORIO_INIT:
      return { ...state, loading: true, isDeleted: false };

    case DELETE_RELATORIO_SUCCESS: {
      const { idRelatorio, msg } = action.payload;

      return {
        ...state,
        relatoriosCadastrados: state.relatoriosCadastrados.filter((r) => r.id !== idRelatorio),
        loading: false,
        isDeleted: true,
        msg,
      };
    }

    case CONSTRUTOR_CONSULTA_NAO_ENCONTRADA:
      return {
        ...state,
        loading: false,
        isConsultaNaoEncontrada: true,
        msg: action.payload.msg,
      };

    case ERROR_CONSTRUTOR_MSG:
      return {
        ...state,
        loading: false,
        isError: true,
        msg: action.payload.msg,
      };

    case CONSTRUTOR_CLEAN_UP:
      return {
        ...INIT_STATE,
      };

    default:
      return state;
  }
}
